import { ChainId } from '@fusionx/sdk'

import useActiveChain from './useActiveChain'

const useChainId = (): ChainId => useActiveChain().id

export default useChainId
